import axios, { AxiosError } from 'axios';
import { IClientScoreResult } from 'interfaces/scoreResult';
import { OdataResponse } from '@pec/aion-ui-odata/types/odataResponse';
import { RootState } from 'combineReducers';
import { sendError } from '@pec/aion-ui-core/sendError';
import { ThunkAction } from 'redux-thunk';
import { IRelease } from '@pec/aion-ui-core/interfaces/release';

const fetchScoreResultsRequest = () =>
  ({
    type: 'FETCH_SCORE_RESULTS_REQUEST'
  } as const);

const fetchScoreResultsSuccess = (payload: { scores: IClientScoreResult[]; clients: IRelease[] }) =>
  ({
    type: 'FETCH_SCORE_RESULTS_SUCCESS',
    payload
  } as const);

const fetchScoreResultsFailure = (error: AxiosError) => {
  sendError(error);
  return {
    type: 'FETCH_SCORE_RESULTS_FAILURE',
    error
  } as const;
};

const shouldFetchScoreResults = (state: RootState) => !state.scoreResults.isFetching || state.scoreResults === null;

const fetchScoreResults = (organizationId: string): ThunkAction<void, RootState, null, Actions> => async dispatch => {
  try {
    dispatch(fetchScoreResultsRequest());

    const {
      data: { value }
    } = await axios.get<OdataResponse<IClientScoreResult[]>>('/api/scoringEngine/v3.1/clientContractorScores', {
      params: {
        $filter: `contractorId eq ${organizationId}`
      }
    });
    const releases = await axios.get<IRelease[]>(`/api/v3.0/organizations/${organizationId}/releases`);
    dispatch(fetchScoreResultsSuccess({ scores: value, clients: releases.data || [] }));
  } catch (error) {
    dispatch(fetchScoreResultsFailure(error));
  }
};

export const fetchScoreResultsIfNeeded = (organizationId: string): ThunkAction<void, RootState, null, Actions> => (
  dispatch,
  getState
) => {
  if (shouldFetchScoreResults(getState())) {
    dispatch(fetchScoreResults(organizationId));
  }
};

export type Actions =
  | ReturnType<typeof fetchScoreResultsRequest>
  | ReturnType<typeof fetchScoreResultsSuccess>
  | ReturnType<typeof fetchScoreResultsFailure>;
